import { api } from '@/lib/api/client'
import type { AdminUserDetail } from '@/services/admin/users'
import { UserEventsPageSchema, type UserEventsPage, type UserEventsParams } from './events'
import type { UserAvatar } from '@/types/UserAvatar'

/** `GET /users/me` — MESMO shape do detalhe de gestão, sem exigir `users:read`:
 *  o dossiê do próprio usuário não precisa do grant que abre o dos outros. */
export async function getMe(): Promise<AdminUserDetail> {
  const { data } = await api.get<AdminUserDetail>('/users/me')
  return data
}

export interface UpdateMePayload {
  name?: string
  email?: string | null // null LIMPA (o back aceita; name null é 422)
  /** `null` APAGA o avatar; chave ausente não toca. */
  avatar?: UserAvatar | null
}

/**
 * `PATCH /users/me` — auto-edição. O payload NÃO tem role, permissions, scopes,
 * sub_roles nem channel_ids, e não é esquecimento: o back recusa, e um form que
 * os oferecesse prometeria escalada de privilégio que não existe.
 *
 * 422 em e-mail ou avatar inválido chega ao caller como `ApiError` (status 422)
 * — quem transforma em erro de campo é a tela.
 */
export async function updateMe(payload: UpdateMePayload): Promise<{ success: boolean }> {
  const { data } = await api.patch<{ success: boolean }>('/users/me', payload)
  return data
}

/** `GET /users/me/events` — mesma trilha e MESMO schema de `GET /users/{id}/events`. */
export async function getMyEvents({ page = 1, limit = 50 }: UserEventsParams = {}): Promise<UserEventsPage> {
  const { data } = await api.get<unknown>('/users/me/events', { params: { page, limit } })
  return UserEventsPageSchema.parse(data)
}
